import styled from 'styled-components';
import Box from '@material-ui/core/Box';
import { Button } from '@material-ui/core';

import NextImage from 'next/image';

export const Map = styled(Box)`
  ${({ theme: { breakpoints } }) => `
      position: relative;
      // width: 358px;
      margin-bottom: 20px;
      height: 86px;

      background: rgba(64, 124, 125, 0.20);
    ${breakpoints.up('md')} {
      width: 100%;
      height: 170px;
      margin-top: 27px;

    }
  `}
`; 
export const Image = styled(NextImage) `
opacity:0.8;
`;

export const ImageWrapper = styled(Box)`
${({ theme: { colors } }) => `
background-color:${colors.greens.green3};
    display: flex;
    align-items: center;
    justify-content: center;
  width: 100%;
  height: 100%;

`}
  
`;


export const OpenMapBtn = styled(Button)`
  ${({ theme: { breakpoints,colors } }) => `
  color: ${colors.greens.green0};

      border-radius: 25px !important;
      border: 3px solid #003C3B;
      position: relative;
      padding: 10px 40px;
      font-size: 18px;
      font-weight: 700;
      width: 90%;
   
      }
    ${breakpoints.up('md')} {
      &:hover {
        background-color: #F2F1F0;
        transition-property: background-color: #000;
        transition-timing-function: cubic-bezier(0.6, 0, 0.3, 2);
        transition-duration: 300ms;
        opacity: 1;
    }
  `}
`;